"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var SpecialPriceController = (function () {
    function SpecialPriceController() {
    }
    SpecialPriceController.addSpecialPriceToPlacement = function (placement, data) {
        if (!data) {
            return;
        }
        var online = placement.conditions.online;
        if (!online) {
            return;
        }
        if (!placement.additionalData) {
            _.set(placement, "additionalData", {});
        }
        var additionalData = placement.additionalData;
        SpecialPriceController.clearSpecialPricePlacementData(online, additionalData, data);
        if (data.specialCpm) {
            online.specialCpm = data.specialCpmAmount;
            delete data.specialFixedPriceAmount;
            additionalData.proprietaryName = data.proprietaryName;
            additionalData.specialPriceData = data;
        }
        if (data.specialFixedPrice) {
            online.specialFixedPrice = data.specialFixedPriceAmount;
            additionalData.specialPriceData.specialCpmAmount = online.specialFixedPrice;
            online.specialFixedPriceIgnoresFrequency = data.specialFixedPriceIgnoresFrequency;
            delete data.specialCpmAmount;
            additionalData.ignoreFrequencyString = data.specialFixedPriceIgnoresFrequency ? "ignoriert" : "berücksichtigt";
            additionalData.proprietaryName = data.proprietaryName;
            additionalData.specialPriceData = data;
        }
        additionalData.proprietaryName = data.proprietaryName;
        additionalData.specialPriceData.description = SpecialPriceController.assignSpecialPriceName(online);
    };
    SpecialPriceController.assignSpecialPriceToPlacement = function (placement) {
        SpecialPriceController.addSpecialPriceToPlacement(placement, {
            specialCpm: placement.conditions.online.specialCpm !== undefined,
            specialCpmAmount: placement.conditions.online.specialCpm,
            specialFixedPrice: placement.conditions.online.specialFixedPrice !== undefined,
            specialFixedPriceAmount: placement.conditions.online.specialFixedPrice,
            specialFixedPriceIgnoresFrequency: placement.conditions.online.specialFixedPriceIgnoresFrequency
        });
    };
    SpecialPriceController.getCalculationType = function (placement, fixedPriceWithShare) {
        if ((_.get(placement, "online.eventualShare") === 1) || fixedPriceWithShare === true) {
            return "Festpreis";
        }
        else {
            return "TKP-Berechn.";
        }
    };
    SpecialPriceController.clearSpecialPricePlacementData = function (online, additionalData, data) {
        additionalData.proprietaryName = undefined;
        additionalData.ignoreFrequencyString = undefined;
        additionalData.specialPriceData = {};
        additionalData.specialPriceData.specialCpm = undefined;
        additionalData.specialPriceData = data;
        _.set(online, "specialCpm", undefined);
        _.set(online, "specialFixedPrice", undefined);
        _.set(online, "specialFixedPriceIgnoresFrequency", undefined);
    };
    SpecialPriceController.assignSpecialPriceName = function (online) {
        var resultString;
        if (!online) {
            return;
        }
        if (online.specialCpm) {
            resultString =
                "TKP " + numeral(online.specialCpm).format(configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY);
        }
        if (online.specialFixedPrice) {
            resultString =
                "FP " + numeral(online.specialFixedPrice).format(configuration_1.PlanConfiguration.NUMBER_FORMAT_CURRENCY);
        }
        return resultString;
    };
    return SpecialPriceController;
}());
exports.SpecialPriceController = SpecialPriceController;
//# sourceMappingURL=SpecialPriceController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/SpecialPriceController.js
// module id = 52
// module chunks = 0